import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  CardHeader,
} from '@mui/material';
import { useCollection } from '../hooks/useFirestore';
import { query as fbQuery, where, orderBy } from 'firebase/firestore';

interface Revenue {
  id: string;
  amount: number;
  type: 'subscription' | 'stripe_fee';
  createdAt: Date;
}

export default function DashboardPage() {
  const { data: revenues } = useCollection<Revenue>(
    'revenues',
    (q) => fbQuery(
      q,
      where('createdAt', '>=', new Date(new Date().setDate(1))),
      orderBy('createdAt', 'desc')
    )
  );

  const stripeFeeRevenue = revenues
    ?.filter(r => r.type === 'stripe_fee')
    .reduce((sum, r) => sum + r.amount, 0) || 0;

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        ダッシュボード
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Stripe決済手数料収益" />
            <CardContent>
              <Typography variant="h3">
                ¥{stripeFeeRevenue.toLocaleString()}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                今月の収益
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
